/**
 * Zod schemas — drafts : filtres URL pour la page `/drafts` (triage cross-œuvres).
 *
 * Pendant logique du `workListFiltersSchema` côté `WorksPage`. Le BE est
 * source de vérité — ces enums sont mirror de `app/schemas/enums.py`
 * (`Platform`, `DraftKind`, `DraftStatus`, `DraftListSort`). Drift détecté
 * via codegen OpenAPI.
 */

import { z } from 'zod'

const draftStatusEnum = z.enum(['pending', 'approved', 'rejected'])
const platformEnum = z.enum(['etsy', 'pinterest', 'instagram', 'saatchi', 'artfinder', 'tiktok'])
const draftKindEnum = z.enum([
  // Refonte drafts v12 — Etsy split en 2 kinds (Physical / Digital). Le
  // legacy `etsy_listing` est purgé par la migration 006 (PR-2).
  'etsy_listing_physical',
  'etsy_listing_digital',
  'pinterest_pin',
  'instagram_carousel_en',
  'instagram_carousel_bilingual',
  'saatchi_listing',
  'artfinder_listing',
  'tiktok_post',
])
const draftListSortEnum = z.enum(['recent', 'oldest', 'work_title'])

/**
 * Coerce un string vers un entier positif (limit/offset URL-coded).
 * Retourne undefined sur invalide pour retomber sur le défaut côté hook.
 */
const positiveIntSchema = z
  .string()
  .optional()
  .transform((v) => {
    if (v === undefined || v === '') return undefined
    const n = Number.parseInt(v, 10)
    return Number.isFinite(n) && n >= 0 ? n : undefined
  })

export const draftListFiltersSchema = z.object({
  q: z.string().optional(),
  status: draftStatusEnum.optional(),
  platform: platformEnum.optional(),
  kind: draftKindEnum.optional(),
  sort: draftListSortEnum.optional(),
  /**
   * Offset utilisé pour la pagination "Charger plus". L'URL le porte pour
   * que back/forward navigateur préservent la position. *Reset à 0 sur
   * tout changement de filtre/sort/q côté hook page* (sinon une bascule
   * `pending → approved` à offset=200 retourne une page vide).
   */
  offset: positiveIntSchema,
})

export type DraftListFiltersInput = z.input<typeof draftListFiltersSchema>
export type DraftListFiltersOutput = z.output<typeof draftListFiltersSchema>
